import { createAction } from 'typesafe-actions';

enum Types {
    OPEN_GATE_STARS = 'openGateStars',
    OPEN_GATE_COINS = 'openGateCoins',
    OPEN_GATE_FRIEND = 'openGateFriend',
}

export const WorldActions = {
    OPEN_GATE_STARS: createAction(
        Types.OPEN_GATE_STARS,
        resolve => (requiredStars: number) => resolve<number>(requiredStars)
    ),
    OPEN_GATE_COINS: createAction(Types.OPEN_GATE_COINS),
    OPEN_GATE_FRIENDS: createAction(Types.OPEN_GATE_FRIEND),
};
